import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'


import UserIndex from '@/entrance/index/UserIndex'
import AdminIndex from '@/entrance/index/AdminIndex'

import UserInfo from '@/pages/user/UserInfo'
import ExchangeList from '@/pages/user/ExchangeList'
import ElectricList from '@/pages/user/ElectricList'
import NoticeList from '@/pages/user/NoticeList'

import DayElectric from '@/pages/admin/DayElectric'
import MonthElectric from '@/pages/admin/MonthElectric'
import Recharge from '@/pages/admin/Recharge'
import Price from '@/pages/admin/Price'
import Concentrator from '@/pages/admin/Concentrator'
import Task from '@/pages/admin/Task'
import GardenAccount from '@/pages/admin/GardenAccount'
import Users from '@/pages/admin/Users'
import  Company from '@/pages/superAdmin/company'
import  MeterProtocol from '@/pages/superAdmin/MeterProtocol'
import  Message from '@/pages/superAdmin/Message'
import DownloadTask from '@/pages/admin/DownloadTask'

Vue.use(Router)
const router = new Router({
    routes: [
        {
            path: '/user',
            name: 'UserIndex',
            component: UserIndex,
            children: [
                {path: '/user/info', component: UserInfo},
                {path: '/user/exchange', component: ExchangeList},
                {path: '/user/electric', component: ElectricList},
                {path: '/user/notice', component: NoticeList},
            ]
        },
        {
            path: '/admin',
            name: 'AdminIndex',
            component: AdminIndex,
            children: [
                {path: '/admin/electric/1', component: DayElectric},
                {path: '/admin/electric/2', component: MonthElectric},
                {path: '/admin/recharge', component: Recharge},
                {path: '/admin/price', component: Price},
                {path: '/admin/con', component: Concentrator},
                {path: '/admin/task', component: Task},
                {path: '/admin/users', component: Users},
                {path: '/admin/ga', component: GardenAccount},
                {path: '/admin/downLoadTask', component: DownloadTask},
            ]
        },
        {
            path: '/superAdmin',
            name: 'superAdmin',
            component: AdminIndex,
            children: [
                {path: '/superAdmin/company', component: Company},
                {path: '/superAdmin/meterProtocol', component: MeterProtocol},
                {path: '/superAdmin/message', component: Message},
            ]
        },





        {
            path: '/hello',
            name: 'HelloWorld',
            component: HelloWorld,
        },
    ]
})
router.afterEach((to, from) => {
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js